



















































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { hls } from '@/units'
import { lowerCase } from '@/utils'

@Component
export default class cogCamera extends Vue {
  // __DATA
  private search: string = ''
  private business: any = null
  private branch: any = null
  private city: any = null
  private area: any = []

  // __METHODS
  private edit (data: any): void {
    this.$emit('events', { type: 'edit', data })
  }

  private remove (data: any): void {
    const conf: boolean = confirm(`Disabled [${data.name}]?`)
    if (conf) {
      this.$emit('events', { type: 'remove', data })
    }
  }

  private h (val: string): string {
    return hls(val, this.search)
  }

  // __COMPUTED
  private get store (): any {
    const search: string = lowerCase(this.search)
    const { cameras }: any = this.db
    let data: any = cameras

    if (this.search) {
      data = data.filter((x: any) => lowerCase(x.name).includes(search))
    }

    if (this.business) {
      data = data.keep('business_id', this.business)
    }

    if (this.branch) {
      data = data.keep('branch_id', this.branch)
    }

    if (this.city) {
      data = data.keep('city_id', this.city)
    }

    if (this.area.length) {
      data = data.filter((x: any) => {
        return this.area.some((n: number) => n === x.area_id)
      })
    }

    return data
  }

  private get db (): any {
    return this.$store.getters['APP.COG/all']
  }
}
